<template>
  <div>
    <v-dialog
      scrollable
      :fullscreen="this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs"
      v-model="invoiceDialog"
      max-width="900"
    >
      <v-card tile flat>
        <v-toolbar
          tile
          card
          flat
          dense
          color="theme_primary"
          class="white--text"
        >
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize"
            >Invoice Details</v-toolbar-title
          >

          <v-spacer></v-spacer>
          <v-toolbar-side-icon>
            <v-icon color="white">assignment</v-icon>
          </v-toolbar-side-icon>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            v-model="invoiceDetail.name"
            required
            label="Name"
            background-color="white"
            autocomplete="noautocomplete"
            box
          />

          <v-text-field
            v-model="invoiceDetail.price_per_mt"
            required
            type="number"
            :label="'Price per mt (in' + customerCurrencyName() + ')'"
            background-color="white"
            box
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="save" flat color="green">Save</v-btn>
          <v-btn @click="invoiceDialog = false" flat color="red">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice details -->
    <v-card flat class="px-4 pb-4">
      <v-subheader>
        Invoice Details
        <v-spacer></v-spacer>
        <v-btn
          v-if="contractInvoiceDetails"
          round
          depressed
          small
          color="gray darken-3"
          @click.stop="applyToAllExpeditions()"
          >Apply to all expeditions</v-btn
        >
      </v-subheader>

      <integratedSearchBar
        :button_display="currentUserCan('create', 'invoice_detail')"
        button_type="function"
        :button_function="displayInvoiceDialog"
        button_label="Add an invoice detail"
        :button_show_label="true"
        :button_is_icon="false"
        :dialog.sync="invoiceDialog"
        v-bind:search.sync="search"
        search_label="Search invoice details..."
      />

      <v-data-table
        hide-actions
        :items="invoiceDetails()"
        sortable
        :search="search"
        :headers="headers"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td style="height: 36px;">{{ props.item.name }}</td>
            <td style="height: 36px;">
              {{ props.item.price_per_mt + customerCurrencyName() }}
            </td>

            <td style="height: 36px;">
              <v-layout>
                <v-btn
                  icon
                  flat
                  round
                  small
                  color="theme_primary"
                  @click="edit(props.item)"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
                <destroyModale
                  resourceName="invoice_detail"
                  :itemId="props.item.id"
                  warningText="You are going to remove this invoice detail permanently."
                  :collection="invoiceDetails()"
                  color="error"
                  small
                  :fab="false"
                  icon
                  :small_icon="true"
                />
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import CREATE_INVOICE_DETAIL from "../../graphql/invoice_details/create.gql";
import UPDATE_INVOICE_DETAIL from "../../graphql/invoice_details/update.gql";
import APPLY_INVOICE_DETAIL from "../../graphql/invoice_details/apply.gql";
import { mapGetters } from "vuex";
import integratedSearchBar from "../shared/integratedSearchBar";

export default {
  components: {
    integratedSearchBar,
  },
  props: {
    expedition: {
      type: Object,
      required: false,
    },
    contractInvoiceDetails: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Price per mt",
          align: "left",
          sortable: true,
          value: "price_per_mt",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          width: "5%",
        },
      ],
      search: "",
      pagination: {
        descending: true,
        rowsPerPage: 25,
      },
      invoiceDialog: false,
      invoiceDetail: {},
    };
  },
  computed: {
    ...mapGetters("contractStore", ["contract"]),
    ...mapGetters("commonStore", ["currencies"]),
  },
  methods: {
    invoiceDetails() {
      if (this.contractInvoiceDetails) return this.contract.invoice_details;
      else return this.expedition.invoice_details;
    },
    customerCurrencyName() {
      let ret = this.currencies.find(
        (c) => c.id == this.contract.customer_currency_id
      );
      return ret ? ret.name : "No customer currency found";
    },
    edit(obj) {
      if (this.contractInvoiceDetails)
        this.invoiceDetail = this.contract.invoice_details.find(
          (i) => (i.id = obj.id)
        );
      else
        this.invoiceDetail = this.expedition.invoice_details.find(
          (i) => (i.id = obj.id)
        );

      this.invoiceDialog = true;
    },
    buttonTitle() {
      return this.invoiceDetail.id ? "Update" : "New";
    },
    iconTitle() {
      return this.invoiceDetail.id ? "refresh" : "add";
    },
    displayInvoiceDialog() {
      this.invoiceDetail = {};
      this.invoiceDialog = true;
    },
    applyToAllExpeditions() {
      this.sendMutation(
        "applied to all expeditions",
        "invoice details",
        APPLY_INVOICE_DETAIL,
        { contract_id: this.contract.id }
      );
    },
    save() {
      this.invoiceDialog = false;
      if (this.contractInvoiceDetails)
        this.invoiceDetail.contract_id = this.contract.id;
      else this.invoiceDetail.expedition_id = this.expedition.id;

      this.invoiceDetail.price_per_mt = parseFloat(
        this.invoiceDetail.price_per_mt
      );
      if (this.invoiceDetail.id) {
        this.sendMutation(
          "updated",
          "invoice detail",
          UPDATE_INVOICE_DETAIL,
          this.invoiceDetail
        );
      } else {
        this.sendMutation(
          "created",
          "invoice detail",
          CREATE_INVOICE_DETAIL,
          this.invoiceDetail
        ).then(() => {
          this.invoiceDetail = {};
        });
      }
    },
  },
};
</script>
